export type SortTrack = { id: string; title: string; artists: string[]; createdAt?: string };
export type LibrarySort = { by: 'recent' | 'title' | 'artist'; direction: 'asc' | 'desc' };
export const librarySortKey = 'simple-music.library-sort.v1';
export function libraryAddedAt(value: unknown): number | null {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const raw = typeof value === 'string' ? value.trim() : value;
  if (raw === '') return null;
  const parsed = /^\d+$/.test(String(raw)) ? Number(raw) : raw;
  if (typeof parsed === 'number' && (!Number.isFinite(parsed) || parsed < 1e9)) return null;
  const time = new Date(typeof parsed === 'number' && parsed < 1e11 ? parsed * 1000 : parsed).getTime();
  return Number.isFinite(time) ? time : null;
}
export function normalizeLibrarySort(value: unknown): LibrarySort {
  const saved = value as Partial<LibrarySort> | null;
  const by = saved && ['recent', 'title', 'artist'].includes(saved.by || '') ? saved.by! : 'recent';
  return { by, direction: saved?.direction === 'asc' || saved?.direction === 'desc' ? saved.direction : by === 'recent' ? 'desc' : 'asc' };
}
export function sortLibraryTracks<T extends SortTrack>(tracks: readonly T[], sort: LibrarySort): T[] {
  const direction = sort.direction === 'desc' ? -1 : 1;
  return tracks.map((track, index) => ({ track, index })).sort((a, b) => {
    if (sort.by === 'recent') {
      const left = libraryAddedAt(a.track.createdAt) ?? -Infinity, right = libraryAddedAt(b.track.createdAt) ?? -Infinity;
      return (left === right ? 0 : left < right ? -1 : 1) * direction || a.index - b.index;
    }
    const left = sort.by === 'title' ? a.track.title : a.track.artists.join(' / ');
    const right = sort.by === 'title' ? b.track.title : b.track.artists.join(' / ');
    return left.localeCompare(right, 'zh-CN', { numeric: true, sensitivity: 'base' }) * direction || a.index - b.index;
  }).map(item => item.track);
}
